<!--
   Empty table message, shown in the middle of the table when there are no rows.
   Use (inside a <td> that spans the whole row):
     <TableEmptyState
        :has-filters="activeFilterCount > 0 || !!tableData.appliedSearchQuery"
        :can-add="$hasPermission('...add')"
        @add="clearForm()"
        @clear="clearAllFilterChips"
     />
   - Filters / search on: "No records match your filters" + Clear filters
   - Nothing at all:      "No records yet" + Add record (only when can-add)
   - title / message / icon can be changed per page.
-->
<template>
   <div class="table-empty-state">
      <i :class="[icon, 'table-empty-icon']"></i>
      <div class="table-empty-title">
         {{ title || (hasFilters ? "No records match your filters" : "No records yet") }}
      </div>
      <div class="table-empty-text">
         {{ message || (hasFilters
            ? "Try a different search, or clear the filters."
            : canAdd ? "Click Add to create the first one." : "Records will show here once they are added.") }}
      </div>

      <button v-if="hasFilters" type="button" class="btn btn-sm btn-secondary mt-2" @click="$emit('clear')">
         <i class="fa fa-times me-1"></i>Clear filters
      </button>
      <button
         v-else-if="canAdd"
         type="button"
         class="btn btn-sm btn-success mt-2"
         data-bs-toggle="modal"
         :data-bs-target="addModal"
         @click="$emit('add')"
      >
         <i class="fa fa-plus me-1"></i>{{ addLabel }}
      </button>
   </div>
</template>

<script>
export default {
   name: "TableEmptyState",
   props: {
      // A search, filter, status tab or "Deleted" view is on
      hasFilters: { type: Boolean, default: false },
      // Show the Add record button (when there are no filters)
      canAdd: { type: Boolean, default: false },
      // The form window the Add button opens
      addModal: { type: String, default: "#recordFormModal" },
      // The Add button's text
      addLabel: { type: String, default: "Add record" },
      // Optional own words / icon for a page
      title: { type: String, default: "" },
      message: { type: String, default: "" },
      icon: { type: String, default: "fa fa-folder-open-o" },
   },
   emits: ["add", "clear"],
};
</script>